import styled from 'styled-components'

import { PairTicker } from '@root/entities/pair/ui/common'
import { PairBoostersBadge } from '@root/entities/pair/ui/pair-information/pair-boosters-badge'
import { PairRank } from '@root/entities/pair/ui/pair-rank'

import type { PairOrCurrencyProps } from '@root/entities/pair/ui/common/pair-ticker'
import type { ClassNameProps } from '@root/shared/react'

type Props = {} & ClassNameProps & PairOrCurrencyProps

export const PairHeadline = (props: Props) => {
  const { className, ...pairOrCurrencyProps } = props
  const quote = props.pair ? props.pair.quote : props.currency
  const premiumInfo = props.pair ? props.pair.premiumInfo : props.premiumInfo

  return (
    <TickerContainer className={className}>
      <PairTickerStyled {...pairOrCurrencyProps} />
      {props.pair ? <PairRank pair={props.pair} /> : undefined}
      {premiumInfo ? (
        <PairBoostersBadge
          currency={quote}
          premiumInfo={premiumInfo}
          mode="explore"
        />
      ) : undefined}
    </TickerContainer>
  )
}

const PairTickerStyled = styled(PairTicker)`
  font-size: var(--typography-body-4-bold-font-size);
  font-weight: var(--typography-body-4-bold-font-weight);
  line-height: var(--typography-body-4-bold-line-height);
  letter-spacing: 0.48px;
`

const TickerContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 4px;
`
